// export const logout = ( state ) => {
// }

export const setSubsidiaries = (state, subsidiaries) => {
    state.subsidiaries = subsidiaries
}

export const setSubsidiariesSelectable = (state, subsidiaries) => {
    state.subsidiariesSelectable = subsidiaries
}

export const setSubsidiarySelect = ( state, subsidiary ) => {
    state.subsidiarySelect = subsidiary
}


export const setSubsidiariesPaginated = (state, subsidiariesPaginatedData) => {
    state.subsidiariesPaginatedData = subsidiariesPaginatedData
}

export const setSubsidiaryDetail = (state, subsidiary) => {
    state.subsidiary = subsidiary
}

export const saveNewSubsidiaries = (state, subsidiary) => {
    state.subsidiaries.unshift(subsidiary)
    state.createdData = subsidiary;
}

export const saveUpdatedSubsidiary = (state, subsidiary) => {
    state.subsidiaries.unshift(subsidiary)
    state.updatedData = subsidiary;
}

export const setDeleteSubsidiary = (state, subsidiary) => {
    state.subsidiariesPaginatedData.data.filter(x => x.id !== subsidiary.id);
    state.deletedData = subsidiary
}

export const setSubsidiaryIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setSubsidiaryIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setSubsidiaryIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setSubsidiaryIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
